import Segment from "./segment";
export var mapResponseSegmentToSegment = function (item) {
    return new Segment(item.id, item.name, item.url, item.global == 1);
};
